import { inject, ref } from 'vue';
import { defineStore } from 'pinia';
import baseAxios from 'axios';
import { useRouteParams } from '@vueuse/router';

import { AXIOS } from '../const';

import * as api from '../router/endpoints';

export const useRoleStore = defineStore('role', () => {
  const axios = inject(AXIOS) || baseAxios;

  const roleList = ref([]);
  const projectId = useRouteParams('projectId');
  const bpId = useRouteParams('bpId');

  const currentRole = ref(null);

  const getRoleListRequest = ref({
    isLoading: false,
    isFinished: false,
    error: null
  });
  const createRoleRequest = ref({
    isLoading: false,
    isFinished: false,
    error: null
  });
  const updateRoleRequest = ref({
    isLoading: false,
    isFinished: false,
    error: null
  });
  const deleteRoleRequest = ref({
    isLoading: false,
    isFinished: false,
    error: null
  });

  function getRoleList() {
    getRoleListRequest.value = {};
    const req = getRoleListRequest.value;
    req.isLoading = true;
    roleList.value = [];
    return axios
      .get(api.roles({ projectId: projectId.value, bpId: bpId.value }), {
        params: { paginated: 0 }
      })
      .then((resp) => {
        roleList.value = resp.data;
      })
      .catch((e) => {
        req.error = e;
        throw e;
      })
      .finally(() => {
        req.isFinished = true;
        req.isLoading = false;
      });
  }

  function createRole(title, name) {
    createRoleRequest.value = {};
    const req = createRoleRequest.value;
    req.isLoading = true;
    return axios
      .post(api.roles({ projectId: projectId.value, bpId: bpId.value }), {
        title, name
      })
      .then((resp) => {
        req.data = resp.data;
      })
      .catch((e) => {
        req.error = e;
        throw e;
      })
      .finally(() => {
        req.isFinished = true;
        req.isLoading = false;
      });
  }

  function updateRole(title, name) {
    updateRoleRequest.value = {};
    const req = updateRoleRequest.value;
    req.isLoading = true;
    return axios
      .post(api.roleById({ projectId: projectId.value, bpId: bpId.value, roleId: currentRole.value.id }), {
        title, name
      })
      .then((resp) => {
        req.data = resp.data;
      })
      .catch((e) => {
        req.error = e;
        throw e;
      })
      .finally(() => {
        req.isFinished = true;
        req.isLoading = false;
      });
  }

  function deleteRole(roleId) {
    deleteRoleRequest.value = {};
    const req = deleteRoleRequest.value;
    req.isLoading = true;
    return axios
      .delete(api.roleById({ projectId: projectId.value, bpId: bpId.value, roleId }))
      .then(() => {
        getRoleList();
      })
      .catch((e) => {
        req.error = e;
        throw e;
      })
      .finally(() => {
        req.isFinished = true;
        req.isLoading = false;
      });
  }

  return {
    currentRole,
    roleList,
    getRoleListRequest,
    createRoleRequest,
    updateRoleRequest,
    deleteRoleRequest,

    getRoleList,
    createRole,
    updateRole,
    deleteRole
  };
});
